export default "__VITE_ASSET__442b1ee7__"